<template>
  <div>
    <span style="display: none">{{loadedScenario}}</span>
    <label class="label">Название сценария</label>
    <p class="control">
      <input v-model="scenario.name" class="input" type="text" placeholder="Введите название сценария">
    </p>
    <label class="label">Сообщение</label>
    <p class="control">
      <input type="radio" v-model="scenario.parameters.questionGenerationState"
             v-bind:value="false"
             @change="onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')">
      <label>Загрузить аудио</label>
      <br/>
      <input type="radio" v-model="scenario.parameters.questionGenerationState"
             v-bind:value="true"
             @change="onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')">
      <label>Сгенерировать аудио</label>
    </p>

    <div v-if="scenario.parameters.questionGenerationState">
      <p class="control">
        <textarea v-model="scenario.parameters.questionText" class="textarea"></textarea>
      <div class="control is-grouped">
        <button class="button is-primary" v-on:click="genAudio('questionId', 'questionAudio', 'generatedQuestionAudio', 'questionText', 'questionLoading', 'question')">
          <span class="icon">
              <i class="fa fa-magic"></i>
            </span>
          <div class="loader spinner" v-if="tmp.questionLoading"></div>
          Сгенерировать аудио
        </button>
        <div class="select is-primary">
          <select v-model="currentSpeaker" class="form-control">
            <option v-for="speaker in speakerList">
              {{speaker.value}}
            </option>
          </select>
        </div>
        <div class="select is-primary">
          <select v-model="currentEmotion" class="form-control">
            <option v-for="emotion in emotionList">
              {{emotion.value}}
            </option>
          </select>
        </div>
        <p>
          <slider size="small" v-bind:value="currentSpeed" :min="0.1" :step="0.1" :max="3" @change="currentSpeed = $event"></slider>
          Скорость:&nbsp{{currentSpeed}}
        </p>
        <audio v-if="tmp.generatedQuestionAudio" :ref="'questionPlayer'">
          <source v-bind:src="scenario.parameters.questionAudio">
          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
        </audio>
        <audio-player v-if="tmp.generatedQuestionAudio" :file="scenario.parameters.questionAudio"/>
      </div>

      </p>
    </div>

    <div v-if="!scenario.parameters.questionGenerationState">
      <p class="control">
      <div class="control">
      <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('loadAudio')">
      <input style="display:none;" @input="loadAudio('loadAudio', 'questionId', 'questionAudio', 'loadedQuestionAudio', 'question', 'questionPlayer')" :id="`loadAudio`" name="load-audio" type="file" accept=".wav,.mp3">
      <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionId', 'questionAudio', 'loadedQuestionAudio', 'question')">
        <audio v-if="tmp.loadedQuestionAudio" :ref="`questionPlayer`">
          <source v-bind:src="scenario.parameters.questionAudio">
          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
        </audio>
        <audio-player v-if="tmp.loadedQuestionAudio" :file="scenario.parameters.questionAudio"/>
      </div>
      </p>
    </div>
    <div v-if="scenario.parameters.questionId!=''">
      <p class="control">
        <button class="button is-link delete-button" v-on:click="deleteAudio('questionId', 'questionAudio', 'loadedQuestionAudio', 'generatedQuestionAudio')">
          <span class="icon">
            <i class="fa fa-minus-circle"></i>
          </span>
          <span>Удалить аудио</span>
        </button>
      </p>
    </div>
    <hr>
    <p class="control">
      <button class="button is-primary" v-on:click="save(true)">
        <span class="icon">
          <i class="fa fa-floppy-o"></i>
        </span>
        <span>Сохранить</span>
      </button>
      <button class="button is-light" v-on:click="cancel">
        <span class="icon">
          <i class="fa fa-times-circle"></i>
        </span>
        <span>Закрыть</span>
      </button>
      <button class="button is-primary">
        <span class="icon">
          <i class="fa fa-calculator"></i>
        </span>
        <span>Рассчитать стоимость</span>
      </button>
      <button v-if="scenario.isReady" class="button is-success is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-info"></i>
        </span>
        <span>Подготовлен</span>
      </button>
      <button v-else class="button is-danger is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-info"></i>
        </span>
        <span>Не подготовлен</span>
      </button>
    </p>
    <modal :visible="showModal" :title=title @confirm="confirmAction" @close="closeModal"></modal>
  </div>
</template>

<script>
  import Cleave from 'vue-cleave'
  import AudioPlayer from '../../../components/audio-player.vue'
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'
  import Message from 'vue-bulma-message'
  import Modal from '../ModalAudio'
  import Slider from 'vue-bulma-slider'

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const MessageComponent = Vue.extend(Message)
  const openMessage = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  }) => {
    return new MessageComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const api = '/api/scenarios'
  const audioGeneratorApi = '/audios/generate'
  const audioUploadApi = '/audios/reSave'
  const audioDeleteApi = '/audios'
  const PROFILES_API = '/api/profiles'

  export default {
    props: ['name', 'campaignid'],
    components: {
      Modal,
      Cleave,
      AudioPlayer,
      Message,
      Notification,
      Slider
    },
    computed: {
      ...mapGetters([
        'loadedScenario',
        'loggedId',
        'loggedUser',
        'authenticationToken'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      insertPause(textareaId) {
        const textarea = document.getElementById(textareaId)
        const pausePattern = ' \\pause:1 '
        if (document.selection) {
          textarea.focus()
          const sel = document.selection.createRange()
          sel.text = pausePattern
        } else if (textarea.selectionStart || textarea.selectionStart == '0') {
          var startPos = textarea.selectionStart
          var endPos = textarea.selectionEnd
          textarea.value = textarea.value.substring(0, startPos) + pausePattern + textarea.value.substring(endPos, textarea.value.length)
          textarea.selectionStart = startPos + pausePattern.length
          textarea.selectionEnd = startPos + pausePattern.length
        } else {
          textarea.value += pausePattern
          textarea.selectionStart = textarea.value.length
        }
        textarea.focus()
      },
      changeRoute: function(e) {
        this.$router.push({path:'/scenarios' + e.target.value})
      },
      checkAudioDuration() {
        this.scenario.checkDuration = true
        var len = document.querySelectorAll('audio').length
        for (var i = 0; i < len; i++) {
          if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
            this.scenario.checkDuration = this.scenario.checkDuration && (document.querySelectorAll('audio')[i].duration > 0)
          }
        }
        return this.scenario.checkDuration
      },
      save (showMessage) {
        if (this.checkAudioDuration()) {
          if (this.scenario.id === undefined) {
            this.saveNew(showMessage)
          } else {
            this.update(showMessage)
          }
        } else {
          this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности')
        }
      },
      saveNew (showMessage) {
        console.log('saving new scenario: ' + JSON.stringify(this.scenario))
        this.scenario.parameters.questionSpeaker = this.tmp.currentSpeaker
        this.scenario.parameters.questionEmotion = this.tmp.currentEmotion
        this.scenario.parameters.questionSpeed = this.tmp.currentSpeed
        if (!this.scenario.parameters.questionGenerationState) {
          this.scenario.parameters.questionText = ''
        }
        this.$http.post(api, this.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.isSaved = true
            if (showMessage) {
              this.openNotificationWithType('info', 'Сценарий сохранен')
              this.$emit('set', this.scenario)
            }
            this.scenario = response.data
          }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
        })
      },
      update (showMessage) {
        console.log('updating scenario: ' + JSON.stringify(this.scenario))
        this.scenario.parameters.questionSpeaker = this.tmp.currentSpeaker
        this.scenario.parameters.questionEmotion = this.tmp.currentEmotion
        this.scenario.parameters.questionSpeed = this.tmp.currentSpeed
        this.$http.put(api, this.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.isSaved = true
            this.scenario = response.data
            if (showMessage) {
              this.openNotificationWithType('info', 'Сценарий сохранен')
            }
          }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
        })
      },
      uploadFile(buttonId) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий')
        } else {
          document.getElementById(buttonId).click()
        }
      },
      genAudioRequest (maybeId, audioName, text) {
        var request = {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'generator': 'yandex',
          'text': text,
          'parameters': {
            'speaker': this.currentSpeaker,
            'emotion': this.currentEmotion,
            'speed': this.currentSpeed,
            'text': text
          }
        }
        if (maybeId) {
          request.id = maybeId
        }
        return request
      },
      prepareLoadAudioRequest (possibleId, uploadAudio) {
        var request = {
          'scenario': this.scenario.id,
          'client': this.scenario.client,
          'audioName': uploadAudio.filename,
          'audioBytes': uploadAudio
        }
        if (possibleId) {
          request.id = id
        }
        return request
      },
      securityHeaders () {
        return {
          'testH': 'testHV',
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
        }
      },
      onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
        if (this.scenario.parameters[stateId]) {
          this.scenario.parameters[audioId] = this.tmp[generatedAudioId]
          this.$refs[playerId][0].load()
        } else {
          this.scenario.parameters[audioId] = this.tmp[loadedAudioId]
          this.$refs[playerId][0].load()
        }
      },
      genAudio(audioId, audioValue, generationType, questionText, loadingStatus, audioName) {
        const request = this.genAudioRequest(this.scenario.parameters[audioId], audioName, this.scenario.parameters[questionText])
        this.handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request)
      },
      handleGenerateRequest (audioId, audioValue, generationType, loadingStatus, request) {
        const headers = {headers: this.securityHeaders()}
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий')
        } else {
          this.tmp[loadingStatus] = true
          this.$http.post(audioGeneratorApi, request, headers)
            .then(response => {
              this.scenario.parameters[audioId] = response.data
              this.tmp[generationType] = `/audios/${this.scenario.parameters[audioId]}.wav`
              this.scenario.parameters[audioValue] = this.tmp[generationType]
              this.tmp[loadingStatus] = false
            })
            .catch(error => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
            })
        }
      },
      loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
        const input = document.querySelector(`#${inputId}`)
        if (input.files && input.files[0]) {
          if (!this.isSaved) {
            this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий')
          } else {
            this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName)
            this.$refs[player].load()
          }
        }
      },
      handleUploadRequest (audioId, audioValue, generationType, audioFile, audioName) {
        this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioID, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders())
          .then(response => {
            this.setAudioValue(audioId, generationType, audioValue, response)
          })
          .catch(error => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
          })
      },
      deleteAudio(audioId, audioValue, generationType1, generationType2) {
        this.$http.delete(`${audioDeleteApi}/${this.scenario.parameters[audioId]}`, {headers: this.prepareUploadHeaders()})
          .then((response) => {
            this.deleteAudioValue(audioId, generationType1, generationType2, audioValue)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка удаления аудио. ')
          })
      },
      prepareMultipartAudio (audioFile, audioId, audioName, audioClient, audioScenario) {
        const audioFormData = new FormData()
        audioFormData.append('file', audioFile)
        audioFormData.append('name', audioName)
        audioFormData.append('client', audioClient)
        audioFormData.append('scenario', audioScenario)
        audioFormData.append('id', this.scenario.parameters[audioId])
        return audioFormData
      },
      prepareUploadHeaders () {
        return {
          'headers': {
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
            'Content-Type': 'multipart/form-data',
            'testH': 'testHV'
          }
        }
      },
      setAudioValue (audioId, generationType, audioValue, response) {
        this.scenario.parameters[audioId] = response.data
        this.tmp[generationType] = `/audios/${this.scenario.parameters[audioId]}.wav`
        this.scenario.parameters[audioValue] = this.tmp[generationType]
      },
      deleteAudioValue (audioId, generationType1, generationType2, audioValue) {
        this.scenario.parameters[audioId] = ''
        this.tmp[generationType1] = ''
        this.tmp[generationType2] = ''
        this.scenario.parameters[audioValue] = ''
      },
      load () {
        this.$http({
          url: api + '/' + this.name,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          console.log('opening scenario ' + JSON.stringify(response.data))
          this.isSaved = true
          this.scenario = response.data
          this.question_audio = '/audios/' + this.scenario.parameters.questionId + '.wav'
        }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки сценария. ')
        })
      },
      cancel () {
        if (this.$props.campaignid == 0) {
          this.$router.push('/scenarios/')
        } else {
          this.$router.push('/campaigns/' + this.$props.campaignid)
        }
      },
      closeModal () {
        this.showModal = false
        this.currentAudio = null
      },
      openModal (audioId, audioValue, generationType, audioName) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий')
        } else {
          this.showModal = true
          this.currentAudio = new FormData()
          this.currentAudio.append('audioId', audioId)
          this.currentAudio.append('audioValue', audioValue)
          this.currentAudio.append('generationType', generationType)
          this.currentAudio.append('audioName', audioName)
        }
      },
      confirmAction (value) {
        this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'))
        this.closeModal()
      },
      notSaved () {
        this.isSaved = false
      },
      loadState () {
        this.$http({
          url: PROFILES_API + '/activeState/' + this.loggedId,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          this.isActive = response.data
          if (!this.isActive) {
            openMessage({
              message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
              type: 'danger',
              showCloseButton: true
            })
          }
        }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].scenarios.errorToGetUserStatus)
        })
      },
      openNotificationWithType (type, message) {
        openNotification({
          title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
          message: message,
          type: type
        })
      }
    },
    data () {
      return {
        scenario: {
          template: 'notification',
          parameters: {
            questionId: '',
            questionAudio: '',
            questionText: '',
            questionGenerationState: true,

            questionSpeaker: 'oksana',
            questionEmotion: 'neutral',
            questionSpeed: 1
          },
          checkDuration: true
        },
        tmp: {
          generatedQuestionAudio: '',
          loadedQuestionAudio: '',
          questionLoading: false
        },
        question_audio: '',
        currentSpeaker: 'oksana',
        speakerList: [
          {
            value: 'jane'
          },
          {
            value: 'oksana'
          },
          {
            value: 'alyss '
          },
          {
            value: 'omazh'
          },
          {
            value: 'zahar '
          },
          {
            value: 'ermil '
          }
        ],
        currentEmotion: 'neutral',
        emotionList: [
          {
            value: 'good'
          },
          {
            value: 'neutral'
          },
          {
            value: 'evil'
          }
        ],
        currentSpeed: 1,
        isSaved: false,
        isActive: false,
        showModal: null,
        title: '',
        currentAudio: null
      }
    },
    created: function () {
      this.loadState()
      if (this.name === undefined) {
        console.log('creating new scenario')
        this.notSaved()
      } else {
        console.log('loading scenario: ' + this.name)
        this.load()
      }
      this.$watch('scenario.parameters.questionAudio', function () {
        this.$refs.questionPlayer.load()
      })
      if (this.loadedScenario) {
        this.isSaved = true
        if (this.scenario.isReady) {
          this.isReady = this.scenario.isReady
          this.scenario = this.loadedScenario
          this.scenario.isReady = this.isReady
        } else {
          this.scenario = this.loadedScenario
        }
        if (this.scenario.parameters.questionGenerationState) {
          this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio
        } else {
          this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio
        }

        this.tmp.currentSpeaker = this.scenario.parameters.questionSpeaker || this.tmp.currentSpeaker
        this.tmp.currentEmotion = this.scenario.parameters.questionEmotion || this.tmp.currentEmotion
        this.tmp.currentSpeed = this.scenario.parameters.questionSpeed || this.tmp.currentSpeed
      }
    },

    beforeUpdate() {
      if (this.loadedScenario) {
        this.isSaved = true
        if (this.scenario.isReady) {
          this.isReady = this.scenario.isReady
          this.scenario = this.loadedScenario
          this.scenario.isReady = this.isReady
        } else {
          this.scenario = this.loadedScenario
        }
        if (this.scenario.parameters.questionGenerationState) {
          this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio
        } else {
          this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio
        }
      }
    }

  }

</script>

<style lang="scss" scoped>
  @import 'node_modules/bulma/sass/utilities/mixins';

  .spinner {
    margin-right: 5px;
  }
  p {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  }

</style>




// WEBPACK FOOTER //
// ScenarioNotice.vue?004a0f10